import { useMemo } from 'react';
import type { LayoutSection } from '../../../types/LayoutConfig';
import { useEnabledPanelTypes } from './useEnabledPanelTypes';

export function useAddablePanelTypes(layoutSection: LayoutSection, additionalSections: LayoutSection[] = []) {
  const enabledPanelTypes = useEnabledPanelTypes();
  const availablePanelTypes = useMemo(
    () =>
      enabledPanelTypes.filter(
        panel => panel.canBeAdded && (panel.section === layoutSection || additionalSections.includes(panel.section))
      ),
    [enabledPanelTypes, layoutSection, additionalSections]
  );
  return availablePanelTypes;
}
